import React from "react";

import { TableContainer, Table, Paper } from "../helper";
import ChallanTableHead from "./ChallanTableHead";
import ChallanTableBody from "./ChallanTableBody";
import ChallanTableFooter from "./ChallanTableFooter";

const ChallanTable = ({
  columnConfig,
  economicCode,
  statusCode,
  searchFields,
  rows,
  populateData,
  params,
  updateParams,
  pageNo,
  downloadCurrent,
}) => {
  return (
    <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
      <Table>
        <ChallanTableHead
          span={columnConfig.length}
          economicCode={economicCode}
          statusCode={statusCode}
          searchFields={searchFields}
          columnConfig={columnConfig}
          params={params}
          updateParams={updateParams}
          downloadCurrent={downloadCurrent}
        />
        <ChallanTableBody
          columnConfig={columnConfig}
          rows={rows}
          uid={"acsRef"}
          params={params}
        />
        <ChallanTableFooter
          span={columnConfig.length}
          populateData={populateData}
          pageNo={pageNo}
        />
      </Table>
    </TableContainer>
  );
};

export default ChallanTable;
